module.exports = __webpack_public_path__ + "images/2803dd3a16109524446e9d1787249d7b-Roboto-Thin.svg";